import { type ComponentProps } from 'react';

export const EyeIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.01991 14.4718C4.33997 13.6436 4 13.2295 4 12C4 10.7705 4.33997 10.3564 5.01991 9.52825C6.37757 7.87467 8.65449 6 12 6C15.3455 6 17.6224 7.87467 18.9801 9.52825C19.66 10.3564 20 10.7705 20 12C20 13.2295 19.66 13.6436 18.9801 14.4718C17.6224 16.1253 15.3455 18 12 18C8.65449 18 6.37757 16.1253 5.01991 14.4718Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
